var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.seconds)?_c('div',{staticClass:"d-flex justify-start mt-5 pl-16"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.countdown))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }